import React from 'react';
import { Add } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';

export const CalendarActions = () => {
  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button startIcon={<Add />} size="small" variant="contained" onClick={() => {}}>
        New Event
      </Button>
    </Stack>
  );
};
